<template>
  <div class="row" style="padding: 20px">
    <div class="col-lg-12" style="margin-left: 10px">
      <div class="main-card mb-12 card">
        <div style="margin: 0px 20px 20px 20px">
          <ul style="color: #000">
            <li
              v-for="(includes, board) in boards"
              :class="{ active: selBoard === board }"
              v-on:click="
                selBoard = board;
                loadBoard();
              "
              v-bind:key="board"
              style="font-size:20px;important;font-weight:bold;"
            >
              <a href="#" data-toggle="tab">{{ board }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                매출
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  통계관리 → 매출
                </div>
              </h5>
              <query-grid :config="config" ref="qg"  
               @update-date-filter="updateDateFilter" 
               @update-paymethod-filter="updatePaymethodFilter">
                <template #search_main="props">
                  <button
                    class="btn btn-danger btn-sm"
                    style="width: 20%"
                    @click="
                      firstselected = 0;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    전체
                  </button>
                  <br />
                  <button
                    class="btn btn-warning btn-sm"
                    style="width: 20%; margin: 2px"
                    v-for="firstlist in firstlists"
                    v-bind:key="firstlist.id"
                    @click="
                      firstselected = firstlist.id;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    {{ firstlist.name }}
                  </button>
                </template>
                <template #search_sub="props">
                  <select
                    v-model="subselected"
                    @change="
                      props.callback(subselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>캠퍼스</option>
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.id"
                      v-bind:key="sublist.id"
                    >
                      {{ sublist.name }}
                    </option>
                  </select>
                </template>
                <template #search_vol="props">
                  <select
                    v-model="volselected"
                    @change="
                      props.callback(volselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>Volume</option>
                    <option
                      v-for="vollist in vollists"
                      :value="vollist.No"
                      v-bind:key="vollist.No"
                    >
                      {{ vollist.Vol }}
                    </option>
                  </select>
                </template>
                <template #items="props">
                  <tr
                    v-for="article in props.records"
                    v-bind:key="article.subid"
                    @click="loadDetails(article)"
                    style="cursor: pointer;"
                  >
                    <td scope="col" style="text-align: center">1</td>
                    <td scope="col" style="text-align: center; padding: 15px 0">
                      {{ article.searchvalue }}
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ article.subid }}
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ parseInt(article.CARD_ONPG).toLocaleString() }} 원
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ parseInt(article.CARD_OFFPG).toLocaleString() }} 원
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ parseInt(article.CASH).toLocaleString() }} 원
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ parseInt(article.subprice).toLocaleString() }} 원
                    </td>
                  </tr>
                </template>
              </query-grid>
              <SalesDetail v-if="clickedItem" :article="clickedItem"   
                                              :cateFilterMain="firstselected"
                                              :cateFilterSub="subselected"
                                              :paymethodFilter="paymethodFilter"
                                              :dateFilter="this.dateFilter"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid_Sales.vue";
import SalesDetail from "../components/detail_pages/SalesDetail.vue";

export default {
  components: {
    QueryGrid,
    SalesDetail,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    sublists: [],
    volselected: "",
    vollists: [],
    clickedItem: null,
    firstselected: "", // cate_filter_main 필터 값
    subselected: "", // cate_filter_sub 필터 값
    paymethodFilter: [],
    dateFilter: { // date_filter 정보
      start: "",
      end: "",
    },
    config: {
      name: "통계관리 매출",
      req_endpoint: "/admin/stat_sales",
      default_limit: 20,
      search_fields: [
        {
          id: "cate_filter_main",
          name: "본부분류",
          type: "custom",
          custom_name: "main",
        },
        {
          id: "cate_filter_sub",
          name: "캠퍼스분류",
          type: "custom",
          custom_name: "sub",
        },
        {
          id: "paymethod_filter",
          name: "결제 방법",
          type: "switch",
          filter_type: {
            CARD_ONPG: "ON 신용카드",
            CARD_OFFPG: "OFF 신용카드",
            CASH: "현금",
          },
        },
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
        },
      ],
      columns: [
        {
          id: "id",
          name: "번호",
          excel_print: (v) => {
            return 1;
          },
        },
        {
          id: "searchvalue",
          name: "검색분류",
          excel_print: (v) => {
            return v.searchvalue;
          },
        },
        {
          id: "countid",
          name: "주문건수",
          excel_print: (v) => {
            return v.subid;
          },
        },
        {
          id: "onpg",
          name: "카드결제(온라인)",
          excel_print: (v) => {
            return v.CARD_ONPG;
          },
        },
        {
          id: "offpg",
          name: "카드결제(오프라인)",
          excel_print: (v) => {
            return v.CARD_OFFPG;
          },
        },
        {
          id: "cash",
          name: "현금",
          excel_print: (v) => {
            return v.CASH;
          },
        },
        {
          id: "sumTotal",
          name: "총합계",
          excel_print: (v) => {
            return v.subprice;
          },
        },
      ],
    },
  }),
  methods: {
    loadBoard() {
      var extras = "?";
      if (this.search) {
        extras += "&search=" + this.search;
      }
      if (this.subselected) {
        extras += "&cate_filter_type=sub&cate_filter_var=" + this.subselected;
      } else if (this.firstselected) {
        extras += "&cate_filter_type=main&cate_filter_var=" + this.firstselected;
      }
      axios.get("/admin/stat_sales" + extras).then((response) => {
        if (response.data.error) {
          alert("매출을 집계할 수 없습니다.\n" + response.data.error);
        } else {
          this.articles = response.data.result.articles;
        }
      });
    },
    viewSecond() {
      this.$refs.qg.pushSetting("cate_filter_sub", null);
      this.subselected = null;
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
    loadDetails(article) {
      if (this.clickedItem === article) {
        this.clickedItem = null;
      } else {
        this.clickedItem = article;
      }
    },
    updateDateFilter(dateFilter) {
      // QueryGrid에서 받은 dateFilter 값을 저장합니다.
      this.dateFilter = dateFilter;
    },
    updatePaymethodFilter(paymethodFilter) {
      this.paymethodFilter = paymethodFilter;
    },
  },
  mounted() {
    axios.get("/admin/sub_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
      }
    });
  },
};
</script>